import React from 'react'
import { useSelector } from 'react-redux'
import CardDiagnosisProcedure from '../../../../../components/common/CardDiagnosisProcedure/CardDiagnosisProcedure'
import PanelCodeHistoryDisplay from '../sharedPanelComponents/PanelCodeHistoryDisplay'
import { isAICPT } from '../sharedPanelComponents/sharedAIfunctions'

export default function PanelChargesDisplay({
  cptTabList,
  onCPTToggle,
  isHistory = false,
  showFav = false,
}) {
  const cptCodes = useSelector((state) => state.sidePanel.panelEncounter?.procedureCodes)
  const features = useSelector((state) => state.user?.features) || []
  const coding_ai = useSelector((state) => state.sidePanel.panelEncounter?.coding_ai)
  const isReadOnly = useSelector((state) => state.sidePanel.isReadOnly)
  const aiCptCodeCheck = useSelector((state) => state.sidePanel.panelEncounter?.aiCptCodeCheck)

  const service_date_from = useSelector(
    (state) => state.sidePanel.panelEncounter?.service_date_from,
  )

  const mapCPT = (cptList) => {
    return cptList.map((resultCpt, index) => (
      <div key={'cpt-display-' + index} style={{ pointerEvents: isReadOnly ? 'none' : '' }}>
        <CardDiagnosisProcedure
          item={resultCpt}
          index={index}
          handleAddRemove={onCPTToggle}
          icon={!cptCodes?.find((cpt) => cpt.code === resultCpt.code) ? 'plus' : 'minus'}
          serviceDate={service_date_from}
          toggleFavorite={showFav}
          type={'PROCEDURE'}
          isAI={
            isAICPT(coding_ai, features, resultCpt?.code) ||
            resultCpt?.code === aiCptCodeCheck?.code
          }
        />
      </div>
    ))
  }

  return (
    <div className={'PanelChargesDisplay'}>
      {cptTabList?.length > 0 ? (
        <div className="display-div">
          {isHistory
            ? cptTabList.map(({ date, cpts }, index) => (
                <React.Fragment key={'cpt-history-display-' + index}>
                  <PanelCodeHistoryDisplay date={date} codes={cpts} display={mapCPT} />
                </React.Fragment>
              ))
            : mapCPT(cptTabList)}
        </div>
      ) : (
        <div id="no-results">
          <p>No results found</p>
        </div>
      )}
    </div>
  )
}
